import React from 'react';
import { connect } from 'react-redux';
import LoadingScreen from 'react-loading-screen';

const InitialLoadingScreen = ({ types, contacts, organisationStructure, myUserProfile, chatNotifications, generalNotifications }) => {
	if (types || contacts || organisationStructure || myUserProfile || chatNotifications || generalNotifications)
		return (
			<LoadingScreen
				loading={true}
				bgColor="#f1f1f1"
				spinnerColor="#2f75ba"
				textColor="#676767"
				logoSrc="assets/images/icon-meldooplus.svg"
				text="MeldooPLUS wird gestartet..."
			>
				<span />
			</LoadingScreen>
		);
	return null;
};

function mapStateToProps({ accountSettings, profile, notifications }) {
	const { types, contacts, organisationStructure } = accountSettings.loading;
	const { myUserProfile } = profile.loading;
	const { chatNotifications, generalNotifications } = notifications.loading;
	return { types, contacts, organisationStructure, myUserProfile, chatNotifications, generalNotifications };
}

export default connect(mapStateToProps)(InitialLoadingScreen);



// WEBPACK FOOTER //
// ./containers/InitialLoadingScreen/index.js